import { Component, OnInit, OnChanges } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Input } from '@angular/core';

@Component({
  selector: 'app-frame',
  templateUrl: './frame.component.html'
})
export class FrameComponent implements OnInit, OnChanges {

    @Input() url: string;
    public safeUrl: SafeResourceUrl;
    constructor(
        public sanitizer: DomSanitizer
    ) {

    }
    public ngOnInit() {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }

    public ngOnChanges() {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/frame/frame.component.ts